export default __webpack_public_path__ + "static/media/keyvisual-moenchengladbach.88fc226f.jpg";